module.exports = __webpack_public_path__ + "static/media/manuale.8dc329d2.pdf";